/** @see https://caniuse.com/mdn-css_properties_scrollbar-width */
export const horizontallyScrollable = Object.freeze({
  // Older Chrome and Safari
  '::-webkit-scrollbar': {
    display: 'none',
  },
  overflowX: 'auto',
  scrollbarWidth: 'none', // Firefox
});
